import React from 'react'
import { useTranslation } from 'react-i18next'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import styles from './styles.module.scss'
import MixrGroupListItem from 'srcReact/components/common2/MixrGroupListItem'
import Avatar from 'srcReact/components/common2/Avatar'
import RadioButton from 'srcReact/components/common2/RadioButton'
import Spinner from 'srcReact/components/common2/Spinner'

function Invite({ selectedGroup, selectedUser, members, loading, lastMemberRef, handleSearch, selectUser }) {
  const { t } = useTranslation()
  return (
    <div className={styles.selectMemberContainer}>
      <MixrGroupListItem
        type='group'
        id={selectedGroup.id}
        title={selectedGroup.name}
        className={styles.selectedGroupContainer}
        titleCSS={styles.selectedGroupName}
        picture={selectedGroup.picture.path}
      />
      <div className={styles.searchOrAdd}>
        <SearchTextBox
          minimumSearchChar={2}
          size='large'
          iconPosition='start'
          placeholder={t('formlabel.searchMemberPlaceholder1')}
          handleSearch={handleSearch}
        />
      </div>
      <div className={styles.members}>
        {members &&
          members.length > 0 &&
          members.map((member, index) => {
            const isLastMember = members.length === index + 1
            return (
              <div className={styles.member} key={`${member.id}_${index}`} ref={isLastMember ? lastMemberRef : null}>
                <Avatar
                  key={'member_' + member.id}
                  userId={member.id}
                  profilePicture={member.profile_picture_url}
                  firstname={member.firstname}
                  lastname={member.lastname}
                  imgWrapperSize='small'
                  mimeType={member.mime_type}
                  originalTag={member.original_tag}
                  isOriginal={member.is_original}
                  withExpertiseGroup={member.with_expertise_group}
                />
                <div className={styles.userProfile}>
                  <div className={styles.memberName}>
                    {member.firstname} {member.lastname}
                  </div>
                </div>

                <RadioButton
                  item={{ value: member }}
                  name={member.id}
                  className={styles.radio}
                  isChecked={selectedUser.id === member.id}
                  onChange={() => selectUser(member)}
                />
              </div>
            )
          })}
      </div>
      {/* members.length == 0  --> do not show spinner if pagination */}
      {loading && members.length == 0 && <Spinner />}
    </div>
  )
}

export default Invite
